import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

BulmaModalLayout.propTypes = {
  modalActions: PropTypes.shape({
    hideModal: PropTypes.func.isRequired,
  }),
  title: PropTypes.string,
}

function BulmaModalLayout({ modalActions, isActive, children }) {
  function requestClose() {
    modalActions.hideModal(null)
  }

  return (
    <div className={classNames('modal', { 'is-active': isActive })}>
      <div className="modal-background" onClick={requestClose} />
      <div
        className="modal-content"
        style={{ background: '#ffff' }}
      >
        {children}
      </div>
      <button
        className="modal-close is-large"
        aria-label="close"
        onClick={requestClose}
      />
    </div>
  )
}

export default BulmaModalLayout



// WEBPACK FOOTER //
// ./src/modules/redux-modal/components/BulmaModalLayout.js